import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { AlertaDetalle } from '../_models/alerta-detalle';

@Injectable({
  providedIn: 'root'
})
export class AlertaDetalleService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/alertasDetalles';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as AlertaDetalle[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( `${this.rutServicio}/enabled` ).pipe( map( res => res as AlertaDetalle[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( `${this.rutServicio}/${id}` ).pipe( map( res => res as AlertaDetalle ) );
  }

  obtenerPorIdAlerta( id: string ) {
    return this.httClient.get( `${this.rutServicio}/alerta/${id}` ).pipe( map( res => res as AlertaDetalle[] ) );
  }

  crear( regCrear: AlertaDetalle ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as AlertaDetalle ) );
  }

  actualizar( regActualizar: AlertaDetalle ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( registros: AlertaDetalle[] ) {
    registros.forEach( r => r.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado() );
    return this.httClient.post( `${this.rutServicio}/bulk`, registros ).pipe( map( res => res as any ) );
  }
}
